import config from "@config"
import { getCookie, setCookie } from "@commonUtils"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const initialState = {
    cities: { data: [] },
    topCities: { data: [] },
    currentCity: config.defaultCity,
    isFetching: false,
    isFetched: false,
    error: null,
    cityData: {
        serviceable: true,
        city: config.defaultCity,
        pharma_available: true,
        otc_available: true,
    },
}

export const locationPickerSlice = createSlice({
    name: "locationPicker",
    initialState: initialState,
    reducers: {
        showLoading: (state) => {
            state.isFetching = true
        },
        updateCurrentCity: (state, action) => {
            state.currentCity = decodeURI(action.payload)
        },
        updateCurrentCityData: (state, action) => {
            state.cityData = action.payload
        },
        updateCities: (state, action) => {
            const { all_cities, top_cities } = action.payload.data
            state.cities.data = all_cities?.data || []
            state.topCities.data = top_cities?.data || []
            state.cities.label = all_cities?.display_text || "All Cities"
            state.topCities.label = top_cities?.display_text || "Popular Cities"
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCities.fulfilled, (state, action) => {
            state.isFetched = true
            state.isFetching = false
            state.cities = {
                data: action.payload.data.all_cities.data,
                label: action.payload.data.all_cities.display_text,
            }
            state.topCities = {
                data: action.payload.data.top_cities.data,
                label: action.payload.data.top_cities.display_text,
            }
        }),
            builder.addCase(fetchCities.pending, (state) => {
                state.isFetching = true
                state.isFetched = false
            }),
            builder.addCase(fetchCities.rejected, (state, action) => {
                state.error = action.payload
                state.isFetching = false
                state.isFetched = false
            })
        builder.addCase(getCurrentLocationCity.fulfilled, (state, action) => {
            const city = getCookie("city")
            const newCity = action.payload?.result[0]?.city
            if (city !== newCity) {
                setCookie("city", newCity)
                state.isFetching = false
                state.currentCity = decodeURI(newCity)
            }
        }),
            builder.addCase(getCurrentLocationCity.pending, (state) => {
                state.isFetching = true
            }),
            builder.addCase(getCurrentLocationCity.rejected, (state, action) => {
                state.error = action.payload
                state.isFetching = false
                state.isFetching = false
            }),
            builder.addCase(getCurrentCityDetails.fulfilled, (state, action) => {
                state.cityData = action.payload.data
                state.isFetching = false
            }),
            builder.addCase(getCurrentCityDetails.pending, (state) => {
                state.isFetching = true
            }),
            builder.addCase(getCurrentCityDetails.rejected, (state, action) => {
                state.error = action.payload.data
                state.isFetching = false
                state.isFetching = false
            })
    },
})

export const fetchCities = createAsyncThunk("locationPicker/fetchCities", async (_arg, { extra }) => {
    const { api } = extra
    return await api.get("/api/v5/cities")
})

export const getCurrentLocationCity = createAsyncThunk(
    "locationPicker/getCurrentLocationCity",
    async ({ lat, long }, { extra, dispatch }) => {
        const { api } = extra
        const res = await api.get(`/location/latlng/${lat},${long}`)
        const city = getCookie("city")
        const newCity = res?.result[0]?.city
        if (city !== newCity) {
            dispatch(getCurrentCityDetails(newCity))
        }
        return res
    }
)

export const getCurrentCityDetails = createAsyncThunk(
    "locationPicker/getCurrentCityDetails",
    async (city, { extra }) => {
        const { api } = extra
        return await api.get(`/api/v4/city-serviceable?city=${escape(city)}`)
    }
)

export const { showLoading, updateCurrentCity, updateCurrentCityData, updateCities } =
    locationPickerSlice.actions
export const locationsReducer = locationPickerSlice.reducer
